var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14.7646C28 22.4966 21.7319 28.7646 14 28.7646C6.26801 28.7646 0 22.4966 0 14.7646C0 7.03266 6.26801 0.764648 14 0.764648C21.7319 0.764648 28 7.03266 28 14.7646ZM9.75748 10.5222C10.1675 10.1121 10.8323 10.1121 11.2424 10.5222L14 13.2797L16.7574 10.5222C17.1675 10.1121 17.8324 10.1121 18.2424 10.5222C18.6525 10.9322 18.6525 11.5971 18.2424 12.0071L15.4848 14.7646L18.2424 17.5221C18.6525 17.9321 18.6525 18.597 18.2424 19.0071C17.8324 19.4171 17.1675 19.4171 16.7574 19.0071L14 16.2496L11.2424 19.0071C10.8324 19.4171 10.1676 19.4171 9.75751 19.0071C9.34746 18.597 9.34746 17.9321 9.75751 17.5222L12.515 14.7646L9.75748 12.0071C9.34742 11.597 9.34742 10.9322 9.75748 10.5222Z",
    fill: "#EBD28D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.8bdd9852de10e0c0c0a5839bccd2dd54.svg";
export { ForwardRef as ReactComponent };